import React, {} from "react"
import {BiCommentDetail} from 'react-icons/bi'
import '../../../css/InfluencerUpload.css'

export default function CommentDiv(props) {
   var comment_outer_div_class_name = 'comment_outer_div_' + props.type;
   var icon_div_class_name = 'comment_icon_div_' + props.type;
   var title_div_class_name = 'comment_title_' + props.type;
   var coming_soon_class_name = 'comment_coming_soon_' + props.type;
   return (
      <div className={comment_outer_div_class_name}>
         <div className={icon_div_class_name}>
            <BiCommentDetail/>
         </div>
         <div className={title_div_class_name}>
            Comments
         </div>
         <div className={coming_soon_class_name}>
            coming soon!
         </div>
      </div>
   )
}
